/** Build display name from vehicle config (make, model, year). */
function generateCarName(config = {}) {
    return [config.make, config.model, config.year].filter(Boolean).join(" ").trim();
}

export default generateCarName;
